import { render, staticRenderFns } from "./classification_search.vue?vue&type=template&id=7afc97fe&"
import script from "./classification_search.vue?vue&type=script&lang=js&"
export * from "./classification_search.vue?vue&type=script&lang=js&"
import style0 from "./classification_search.vue?vue&type=style&index=0&id=7afc97fe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports